const MoreWhiteIcon: React.FC = () => {
  return (
    <svg width="6" height="11" viewBox="0 0 6 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L5 5.5L1 10" stroke="#676767" />
    </svg>
  );
};
export default MoreWhiteIcon;
